<script>
	export let title = "";
	export let body = "";
</script>

<div class="UIContact">
	{#if title}
		<h3>{@html title.split("\n").join("<br>")}</h3>
	{/if}
	<p>
		{@html body.split("\n").join("<br>")}
	</p>
</div>

<style global>
	.UIContact {
		padding: 3em 0 5em 0;
		text-align:center;
		font-size: 1.1em;
	}
	:global(.pc) .UIContact {
		padding: 4em;
		font-size: 1.125em;
	}
	.UIContact h3 {
		font-size: 1.95em;
    padding-bottom: 0.65em;
	}
	:global(.pc) .UIContact h3 {
		font-size: 2.6em;
		padding-bottom:0.7em;
	}
	.UIContact h4 {
		font-size: 1.1em;
	}
	.UIContact p hr {
    border: none;
    border-top: solid 2px #d6d5d5;
		width:60px;
    height: 2px;
		margin:1.8em auto;
	}
	:global(.pc) .UIContact p hr {
		width:160px;
		margin:2.2em auto;
	}
	.UIContact p {
		font-size: 0.95em;
	}
	:global(.pc) .UIContact p {
		font-size: 1.1em;
	}
</style>
